module.exports = __webpack_public_path__ + "img/smart2.904dfc1a.svg";